import React, { useImperativeHandle, useState } from "react";
import styles from "./index.module.scss";
import { sleep } from "utils/common";
import PageHomeworkReview, { UrlParams } from "../../../../../detail";
import {
    getFilesFromSelector,
    getImagesFromSelector,
    takeSnapshot,
    waitUntilLoaded
} from "../../../../../../../service/dom";

export interface PaperPDFInstance {
    load(params: UrlParams): Promise<void>;
    getBlob(): Promise<Blob>;
    getFiles(): string[];
}

export const PaperPDF = React.forwardRef<PaperPDFInstance>((_, ref) => {
    const [params, setParams] = useState<UrlParams>();

    useImperativeHandle(ref, () => ({
        load,
        getBlob,
        getFiles
    }));

    async function load(params: UrlParams) {
        // 先释放之前的试卷, 这样才能用过dom来判断新试卷是否加载完毕
        setParams(undefined);
        await sleep(0);
        setParams(params);

        const selector = `.${styles.root} [class^=HomeworkDetail_block]`;
        await waitUntilLoaded(selector, 10 * 1000);
    }

    async function getBlob() {
        return takeSnapshot(`.${styles.root} .${styles.wrapper} > div`);
    }

    function getFiles() {
        const files = getFilesFromSelector(
            "[class^=QuestZhuguan_content].globalISROOTS"
        );

        const images1 = getImagesFromSelector(
            "[class^=QuestZhuguan_content].globalISROOTS"
        );

        const images2 = getImagesFromSelector("[class^=FilesList_listWrapper]");

        return [...files, ...images1, ...images2];
    }

    return (
        <div className={styles.root}>
            <div className={styles.wrapper}>
                {params && <PageHomeworkReview match={{ params }} />}
            </div>
        </div>
    );
});
